import type { TopPickTile } from '~/contracts/dealership';
import encodeBase64 from '~/utilities/encodeBase64';
import { testDriveCenterImages } from './assets';

function buildCvnaId(make: string, parentModel: string): string {
  return encodeBase64(
    JSON.stringify({
      filters: {
        makes: [{ name: make, parentModels: [{ name: parentModel }] }]
      }
    })
  );
}

const topPicks: TopPickTile[] = [
  {
    name: 'Jeep Wrangler',
    image: testDriveCenterImages.topPickJeepWrangler,
    blurb:
      'Iconic and trail-ready, the Wrangler delivers pure off-road freedom with style and rugged durability.',
    cvnaId: buildCvnaId('Jeep', 'Wrangler')
  },
  {
    name: 'Ram 2500',
    image: testDriveCenterImages.topPickRam2500,
    blurb:
      'Engineered for heavy lifting, the Ram 2500 blends strength, comfort, and capability in one tough truck.',
    cvnaId: buildCvnaId('Ram', '2500')
  },
  {
    name: 'Jeep Grand Cherokee',
    image: testDriveCenterImages.topPickJeepGrandCherokee,
    blurb:
      'Grand Cherokee offers refined comfort with the capability to handle any terrain.',
    cvnaId: buildCvnaId('Jeep', 'Grand Cherokee')
  },
  {
    name: 'Jeep Gladiator',
    image: testDriveCenterImages.topPickJeepGladiator,
    blurb:
      'Rugged like a Wrangler, but with a truck bed— the Gladiator is your ultimate utility adventure vehicle.',
    cvnaId: buildCvnaId('Jeep', 'Gladiator')
  }
];

export default topPicks;
